export default "__VITE_ASSET__Cud2NYh7__"